import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import AulaAssistirArea from '../components/common/aula/aula-assistir';
import Cta from '../components/common/cta/cta';
import SEO from '../components/seo';
import Footer from '../layout/footers/footer';
import Header from '../layout/headers/header';
import Wrapper from '../layout/wrapper';

const DynamicAulaAssistirDetails = () => {

  const { idModulo, idAula } = useParams();
  const navigate = useNavigate();

  return (
    <Wrapper>
      {/* seo start */}
      <SEO pageTitle={'Assistir Aula'} />
      {/* seo end */}

      {/* header start */}
      <Header header_shadow={true} />
      {/* header end */}

      {/* aula details */}
      <AulaAssistirArea idModulo={idModulo} idAula={idAula} />
      {/* aula details */}

      {/* footer start */}
      <Footer />
      {/* footer end */}
    </Wrapper>
  );
};

export default DynamicAulaAssistirDetails;